<template>
  <transition name="bubble-fade">
    <div 
      v-if="showBubble"
      @mouseenter="pauseRotation"
      @mouseleave="resumeRotation"
      class="payment-bubble"
    >
      <div class="bubble-content">
        <div class="avatar-section">
          <div class="avatar" :style="{ backgroundColor: currentPayment.color }">
            <v-icon color="white">mdi-cash-multiple</v-icon>
          </div>
        </div>
        
        <div class="info-section">
          <div class="user-email">{{ currentPayment.email }}</div>
          <div class="payment-details">
            <span class="action-text">{{ $t('moreMoney.paymentBubble.withdrew') }}</span>
            <span class="amount-highlight">${{ currentPayment.amount }} USD</span>
          </div>
          <div class="timestamp">
            <v-icon size="12" color="#999">mdi-clock-outline</v-icon>
            <span>{{ currentPayment.time }}</span>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
import axios from '@/axios.js';

export default {
  name: 'PaymentNotificationBubble',
  data() {
    return {
      showBubble: true,
      currentIndex: 0,
      rotationInterval: null,
      isPaused: false,
      payments: []
    };
  },
  computed: {
    currentPayment() {
      return this.payments[this.currentIndex];
    }
  },
  mounted() {
    this.startRotation();
    this.getWithdrawals();
  },
  beforeDestroy() {
    this.stopRotation();
  },
  methods: {
   startRotation() {
      this.rotationInterval = setInterval(() => {
        if (!this.isPaused) {
          this.showBubble = false;
          
          setTimeout(() => {
            this.currentIndex = (this.currentIndex + 1) % this.payments.length;
            this.showBubble = true;
          }, 1000);
        }
      }, 5000); // Cambia cada 5 segundos
    },
    stopRotation() {
      if (this.rotationInterval) {
        clearInterval(this.rotationInterval);
      }
    },
    pauseRotation() {
      this.isPaused = true;
    },
    resumeRotation() {
      this.isPaused = false;
    },
    getWithdrawals() {
      axios.get('get-withdrawal-users')
        .then(response => {
        this.payments = response.data.withdrawals.map(withdrawal => ({
            email: withdrawal.email,
            amount: withdrawal.amount,
            time: this.generateRandomTime(),
            color: this.generateRandomColor()
          }) );
        })
        .catch(error => {
          console.error('Error al obtener los retiros:', error);
        });
    },
    generateRandomTime() {
      const options = [
        { max: 59, unit:this.$t('moreMoney.paymentBubble.timeUnits.minutes') },
        { max: 23, unit: this.$t('moreMoney.paymentBubble.timeUnits.hours') },
        { max: 3, unit: this.$t('moreMoney.paymentBubble.timeUnits.days') }
      ];
      
      // Elegir aleatoriamente entre minutos, horas o días
      const timeType = options[Math.floor(Math.random() * options.length)];
      const value = Math.floor(Math.random() * timeType.max) + 1;
      
      return `${this.$t('moreMoney.paymentBubble.ago')} ${value} ${timeType.unit}`;
    },
    generateRandomColor() {
      const colors = [
        '#00D4AA', // Verde turquesa
        '#9C27B0', // Morado
        '#FF6B35', // Naranja
        '#2196F3', // Azul
        '#E91E63', // Rosa
        '#FF9800', // Naranja dorado
        '#00BCD4', // Cian
        '#4CAF50', // Verde
        '#673AB7', // Morado oscuro
        '#F44336'  // Rojo
      ];
      
      return colors[Math.floor(Math.random() * colors.length)];
    }
  }
};
</script>

<style scoped>
.payment-bubble {
  position: fixed;
  top: 110px;
  left: 20px;
  z-index: 5;
  background: linear-gradient(135deg, #ffffff 0%, #f8f9ff 100%);
  border-radius: 40px;
  padding: 12px 18px;
  min-width: 300px;
  max-width: 310px;
  cursor: pointer;
  transition: all 0.3s cubic-bezier(0.4, 0, 0.2, 1);
  border: 2px solid rgba(156, 39, 176, 0.15);
  backdrop-filter: blur(12px);
}


.bubble-content {
  display: flex;
  align-items: center;
  gap: 16px;
}

.avatar-section {
  flex-shrink: 0;
}

.avatar {
  width: 50px;
  height: 50px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 4px 16px rgba(0, 0, 0, 0.2);
  animation: pulse 2s ease-in-out infinite;
}

.avatar-icon {
  font-size: 24px;
  font-weight: bold;
  color: white;
}

@keyframes pulse {
  0%, 100% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
}

.info-section {
  display: flex;
  flex-direction: column;
  gap: 6px;
  min-width: 0;
}

.user-email {
  font-weight: 700;
  font-size: 14px;
  color: #9C27B0;
  letter-spacing: 0.2px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.payment-details {
  display: flex;
  align-items: center;
  gap: 6px;
  flex-wrap: wrap;
}

.action-text {
  color: #666;
  font-weight: 500;
  font-size: 13px;
}

.amount-highlight {
  font-weight: 800;
  font-size: 16px;
  color: #00D4AA;
  text-shadow: 0 2px 2px rgba(0, 212, 170, 0.25);
  letter-spacing: 0.3px;
}

.timestamp {
  display: flex;
  align-items: center;
  gap: 4px;
  font-size: 12px;
  color: #999;
  font-style: italic;
}

/* Animaciones de transición */
.bubble-fade-enter-active {
  animation: slideInLeft 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

.bubble-fade-leave-active {
  animation: slideOutLeft 0.5s cubic-bezier(0.4, 0, 0.2, 1);
}

@keyframes slideInLeft {
  from {
    opacity: 0;
    transform: translateX(-100px) scale(0.8);
  }
  to {
    opacity: 1;
    transform: translateX(0) scale(1);
  }
}

@keyframes slideOutLeft {
  from {
    opacity: 1;
    transform: translateX(0) scale(1);
  }
  to {
    opacity: 0;
    transform: translateX(-100px) scale(0.8);
  }
}

/* Responsive */
@media (max-width: 768px) {
  .payment-bubble {
    top: 80px;
    left: 10px;
    right: 10px;
    min-width: auto;
    max-width: calc(100% - 20px);
    padding: 14px 16px;
  }
  
  .avatar {
    width: 46px;
    height: 46px;
  }
  
  .avatar-icon {
    font-size: 22px;
  }
  
  .user-email {
    font-size: 13px;
  }
  
  .action-text {
    font-size: 12px;
  }
  
  .amount-highlight {
    font-size: 15px;
  }
}

@media (max-width: 480px) {
  .payment-bubble {
    top: 75px;
    padding: 12px 14px;
  }
  
  .bubble-content {
    gap: 12px;
  }
}
</style>
